module.exports = __webpack_public_path__ + "img/pink-order.3bfbfa8a.png";